import './adobeAnalytics';
import './styles/index.scss';
import { HashRouter as Router, Switch } from 'react-router-dom';
import Partnerships from './layouts/Partnerships';
import Discover from './layouts/Discover';
import Explore from './layouts/Explore';
import Experience from './layouts/Experience';
import Videos from './layouts/Videos';
import CarFeature from './layouts/CarFeature';
import Origami from './layouts/Origami';
import OrigamiGallery from './layouts/OrigamiGallery';
import { view } from '@risingstack/react-easy-state';
import TransitionVideo from './components/TransitionVideo';
import MainFooter from './components/MainFooter';
import OrigamiShare from './layouts/OrigamiShare';
import AriyaGame from './layouts/AriyaGame';
import AriyaGameShare from './layouts/AriyaGameShare';

import { LocaleRoute, useLocale, useRelativeRoute } from './Locale';

function AppRouter() {
  return (
    <>
      <Switch>
        {useRelativeRoute('discover', <Discover />)}
        {useRelativeRoute('explore', <Explore />)}
        {useRelativeRoute('experience', <Experience />)}
        {useRelativeRoute('videos', <Videos />)}
        {useRelativeRoute('feature', <CarFeature />)}
        {useRelativeRoute('partnership', <Partnerships />)}
        {useRelativeRoute('origami', <Origami />)}
        {useRelativeRoute('origami-gallery', <OrigamiGallery />)}
        {useRelativeRoute('origami-share/:color/:pattern/:message', <OrigamiShare />)}
        {useRelativeRoute('origami-share', <OrigamiShare />)}
        {useRelativeRoute('nissan-ariya', <AriyaGame />)}
        {useRelativeRoute('nissan-ariya-sharetest', <AriyaGameShare />)}
        {useRelativeRoute('.', <Partnerships />)}
      </Switch>
    </>
  );
}

function BaseRouter() {
  const locale = useLocale();
  const dir = locale === 'ar' ? 'rtl' : 'ltr';
  //document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', locale);

  const content = window.redemptionInfo ? <OrigamiShare redemptionInfo={window.redemptionInfo} /> : (window.ariyaInfo ? <AriyaGame /> : <AppRouter />);

  return (
    <>
      {content}
      <MainFooter />
    </>
  );
}

function App() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  return (
    <div className="page">
      <TransitionVideo />
      <Router>
        <LocaleRoute component={BaseRouter} />
      </Router>
    </div>
  );
}

export default view(App);
